import Simulator from "./Simulator";
import TypeAhead from "./TypeAhead";
import Title from "./ui/Title";

const Meldings = ({selectedMeldings, setSelectedMeldings, autoUpdate, setAutoUpdate}: {selectedMeldings: string[], setSelectedMeldings: React.Dispatch<React.SetStateAction<string[]>>, autoUpdate: boolean, setAutoUpdate: React.Dispatch<React.SetStateAction<boolean>>}) => {
    
    return (
        <div className="w-full justify-end items-end text-center flex flex-col gap-4">
            <div className="w-full flex flex-row justify-between items-center">
                <div className="text-center text-nowrap"><Title title="Dispatch Centre Simulation" /></div>
                <Simulator setSelectedItems={setSelectedMeldings} />
                <div className="flex flex-row gap-2 items-center">
                    <input className="w-5 h-5 cursor-pointer" type="checkbox" checked={autoUpdate} onChange={() => setAutoUpdate(!autoUpdate)} />
                    <label>Auto Update</label>
                </div>
            </div>
            <TypeAhead csvPath="/Meldingsclassificaties.csv" selectedItems={selectedMeldings} setSelectedItems={setSelectedMeldings} />         
        </div>
    )
}

export default Meldings;